<!--  -->
<template>
  <div class="foot">
    <div class="w1200">
      <div class="z3_we">
        <div class="content">
          <p id="z_xia">
             <a href="https://beian.miit.gov.cn/#/Integrated/index" id="z_hui">ICP备案证书号:浙ICP备2023038468号-4</a>
          </p>
          <p>
            <!-- <a id="z_hui2"
              >版权所有 © 2005-2021 大商创,并保留所有权利。</a
            > -->
            <a id="z_hui2"
              >Copyright © 2023-2024 杭州盈来科技有限公司 版权所有 Management Professional Group. All Rights Reserved.</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "ComponentName",
  data() {
    //这里存放数据
    return {};
  },
  created() {},
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
};
</script>
<style lang="less" scoped>
.foot {
  background: #262626;
  width: 100%;
  .w1200 {
    width: 1200px;
    background: #fff;
    margin: 0 auto;
  }
}
a {
  text-decoration: none;
}
.z3_we {
  width: 100%;
  height: 66px;
  background-color: #262626;
  .content {
    width: 1200px;
    height: 66px;
    margin: 0px auto;
    font-size: 12px;
    line-height: 30px;
    p {
      text-align: center;
    }
  }
}
#z_hui,
#z_hui2 {
  color: #555;
}
</style>>